/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  IptrademarkIpTrademarkProtocolAddCustomColumnTitleRequest,
  IptrademarkIpTrademarkProtocolAddCustomColumnTitleResponse,
  IptrademarkIpTrademarkProtocolAddCustomColumnValueRequest,
  IptrademarkIpTrademarkProtocolAddIpTmWithNumberRequest,
  IptrademarkIpTrademarkProtocolAddIpTrademarkWithRegiCertificateRequest,
  IptrademarkIpTrademarkProtocolAddTmWithFileRequest,
  IptrademarkIpTrademarkProtocolAddTmWithFileResponse,
  IptrademarkIpTrademarkProtocolDeleteColumnTitleRequest,
  IptrademarkIpTrademarkProtocolDeleteIpTmNoticeResponse,
  IptrademarkIpTrademarkProtocolDeleteIpTrademarkRequest,
  IptrademarkIpTrademarkProtocolGetColumnTitleListResponse,
  IptrademarkIpTrademarkProtocolGetDownloadUrlRequest,
  IptrademarkIpTrademarkProtocolGetDownloadUrlResponse,
  IptrademarkIpTrademarkProtocolGetIpTmNoticeResponse,
  IptrademarkIpTrademarkProtocolGetIpTmRegistrationListRequest,
  IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponse,
  IptrademarkIpTrademarkProtocolGetIpTmResponse,
  IptrademarkIpTrademarkProtocolGetIpTmSampleFileUrlResponse,
  IptrademarkIpTrademarkProtocolGetIpTrademarkDetailsRequest,
  IptrademarkIpTrademarkProtocolGetIpTrademarkDetailsResponse,
  IptrademarkIpTrademarkProtocolGetLanguageCodeListResponse,
  IptrademarkIpTrademarkProtocolGetRegiCertifiPresignedUrlRequest,
  IptrademarkIpTrademarkProtocolGetRegiCertifiPresignedUrlResponse,
  IptrademarkIpTrademarkProtocolUpdateColumnOrderRequest,
  IptrademarkIpTrademarkProtocolUpdateColumnTitleRequest,
  IptrademarkIpTrademarkProtocolUpdateIpTmAdditionalInfoRequest,
  IptrademarkIpTrademarkProtocolUpdateIpTrademarkDetailsRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class IpTrademark<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Trademark
   * @name RegiCertificatePresignedCreate
   * @request POST:/ip-trademark/regi-certificate/presigned
   */
  regiCertificatePresignedCreate = (
    data: IptrademarkIpTrademarkProtocolGetRegiCertifiPresignedUrlRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetRegiCertifiPresignedUrlResponse, any>({
      path: `/ip-trademark/regi-certificate/presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name NewRegiCertificateCreate
   * @request POST:/ip-trademark/new/regi-certificate
   */
  newRegiCertificateCreate = (
    data: IptrademarkIpTrademarkProtocolAddIpTrademarkWithRegiCertificateRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/ip-trademark/new/regi-certificate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name NewSingleCreate
   * @request POST:/ip-trademark/new/single
   */
  newSingleCreate = (data: IptrademarkIpTrademarkProtocolAddIpTmWithNumberRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip-trademark/new/single`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name DetailsCreate
   * @request POST:/ip-trademark/details
   */
  detailsCreate = (data: IptrademarkIpTrademarkProtocolGetIpTrademarkDetailsRequest, params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetIpTrademarkDetailsResponse, any>({
      path: `/ip-trademark/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name DeleteCreate
   * @request POST:/ip-trademark/delete
   */
  deleteCreate = (data: IptrademarkIpTrademarkProtocolDeleteIpTrademarkRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip-trademark/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name ListCreate
   * @request POST:/ip-trademark/list
   */
  listCreate = (data: IptrademarkIpTrademarkProtocolGetIpTmRegistrationListRequest, params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponse, any>({
      path: `/ip-trademark/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name ColumnTitleListList
   * @request GET:/ip-trademark/column/title/list
   */
  columnTitleListList = (params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetColumnTitleListResponse, any>({
      path: `/ip-trademark/column/title/list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name ColumnTitleUpdateCreate
   * @request POST:/ip-trademark/column/title/update
   */
  columnTitleUpdateCreate = (
    data: IptrademarkIpTrademarkProtocolUpdateColumnTitleRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/ip-trademark/column/title/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name ColumnTitleAddCreate
   * @request POST:/ip-trademark/column/title/add
   */
  columnTitleAddCreate = (
    data: IptrademarkIpTrademarkProtocolAddCustomColumnTitleRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<IptrademarkIpTrademarkProtocolAddCustomColumnTitleResponse, any>({
      path: `/ip-trademark/column/title/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name ColumnTitleDeleteCreate
   * @request POST:/ip-trademark/column/title/delete
   */
  columnTitleDeleteCreate = (
    data: IptrademarkIpTrademarkProtocolDeleteColumnTitleRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/ip-trademark/column/title/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name ColumnTitleOrderUpdateCreate
   * @request POST:/ip-trademark/column/title/order/update
   */
  columnTitleOrderUpdateCreate = (
    data: IptrademarkIpTrademarkProtocolUpdateColumnOrderRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/ip-trademark/column/title/order/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name ColumnCustomAddCreate
   * @request POST:/ip-trademark/column/custom/add
   */
  columnCustomAddCreate = (
    data: IptrademarkIpTrademarkProtocolAddCustomColumnValueRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/ip-trademark/column/custom/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name IpTmListList
   * @request GET:/ip-trademark/ipTm/list
   */
  ipTmListList = (params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetIpTmResponse, any>({
      path: `/ip-trademark/ipTm/list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name NewMultipleSampleList
   * @request GET:/ip-trademark/new/multiple/sample
   */
  newMultipleSampleList = (params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetIpTmSampleFileUrlResponse, any>({
      path: `/ip-trademark/new/multiple/sample`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name NewFileCreate
   * @request POST:/ip-trademark/new/file
   */
  newFileCreate = (data: IptrademarkIpTrademarkProtocolAddTmWithFileRequest, params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolAddTmWithFileResponse, any>({
      path: `/ip-trademark/new/file`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name UpdateCreate
   * @request POST:/ip-trademark/update
   */
  updateCreate = (data: IptrademarkIpTrademarkProtocolUpdateIpTrademarkDetailsRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip-trademark/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name NoticeList
   * @request GET:/ip-trademark/notice
   */
  noticeList = (params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetIpTmNoticeResponse, any>({
      path: `/ip-trademark/notice`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name AdditionalInfoUpdateCreate
   * @request POST:/ip-trademark/additional-info/update
   */
  additionalInfoUpdateCreate = (
    data: IptrademarkIpTrademarkProtocolUpdateIpTmAdditionalInfoRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/ip-trademark/additional-info/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name UrlDownloadCreate
   * @request POST:/ip-trademark/url/download
   */
  urlDownloadCreate = (data: IptrademarkIpTrademarkProtocolGetDownloadUrlRequest, params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetDownloadUrlResponse, any>({
      path: `/ip-trademark/url/download`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name LanguageListList
   * @request GET:/ip-trademark/language/list
   */
  languageListList = (params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolGetLanguageCodeListResponse, any>({
      path: `/ip-trademark/language/list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Trademark
   * @name NoticeDeleteList
   * @request GET:/ip-trademark/notice/delete
   */
  noticeDeleteList = (params: RequestParams = {}) =>
    this.http.request<IptrademarkIpTrademarkProtocolDeleteIpTmNoticeResponse, any>({
      path: `/ip-trademark/notice/delete`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
